<div class="popup-overlay">
  <div class="popup-container" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="close()">
      <i class="fas fa-times"></i>
    </button>
    
    <div class="popup-header">
      <h2>Register for Training</h2>
      <p>Fill out the form to enroll in our training program</p>
    </div>
    
    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" class="registration-form">
      <div class="form-group">
        <label for="fullName">Full Name</label>
        <input type="text" id="fullName" formControlName="fullName" placeholder="Enter your full name">
        <div *ngIf="submitted && getFormControl('fullName')?.errors" class="error-message">
          <span *ngIf="getFormControl('fullName')?.errors?.['required']">Full name is required</span>
          <span *ngIf="getFormControl('fullName')?.errors?.['minlength']">Minimum 3 characters required</span>
        </div>
      </div>
      
      <div class="form-group">
        <label for="email">Email Address</label>
        <input type="email" id="email" formControlName="email" placeholder="Enter your email">
        <div *ngIf="submitted && getFormControl('email')?.errors" class="error-message">
          <span *ngIf="getFormControl('email')?.errors?.['required']">Email is required</span>
          <span *ngIf="getFormControl('email')?.errors?.['email']">Please enter a valid email</span>
        </div>
      </div>
      
      <div class="form-group">
        <label for="phone">Phone Number</label>
        <input type="tel" id="phone" formControlName="phone" placeholder="Enter 10-digit phone number">
        <div *ngIf="submitted && getFormControl('phone')?.errors" class="error-message">
          <span *ngIf="getFormControl('phone')?.errors?.['required']">Phone number is required</span>
          <span *ngIf="getFormControl('phone')?.errors?.['pattern']">Please enter a valid 10-digit number</span>
        </div>
      </div>
      
      <div class="form-group">
        <label for="course">Select Course</label>
        <select id="course" formControlName="course">
          <option value="" disabled selected>Choose a course</option>
          <option value="content-creation">Content Creation Mastery</option>
          <option value="video-editing">Professional Video Editing</option>
          <option value="youtube-growth">YouTube Growth Strategies</option>
        </select>
        <div *ngIf="submitted && getFormControl('course')?.errors" class="error-message">
          <span *ngIf="getFormControl('course')?.errors?.['required']">Please select a course</span>
        </div>
      </div>
      
      <div class="form-group checkbox-group">
        <input type="checkbox" id="agreeTerms" formControlName="agreeTerms">
        <label for="agreeTerms">I agree to the terms and conditions</label>
        <div *ngIf="submitted && getFormControl('agreeTerms')?.errors" class="error-message">
          <span>You must agree to the terms</span>
        </div>
      </div>
      
      <button type="submit" class="submit-btn">Register Now</button>
    </form>
  </div>
</div>